/**
 * Modelo de histórico de pagamento de IPVA/Licenciamento (VehicleIpvaLicensingPaymentHistoryDTO).
 */
export interface VehicleIpvaLicensingPaymentHistory {
  id: number;
  vehicleId: number;
  paymentType: 'IPVA' | 'Licenciamento';
  referenceYear: number;
  paymentDate: string | null;
  amount: number | null;
  status: string;
  documentNumber: string | null;
  externalReference: string | null;
  notes: string | null;
}

/**
 * Resposta do provedor bancário (GET bank-provider).
 */
export interface VehicleIpvaLicensingBankProvider {
  isAvailable: boolean;
  providerName: string;
}

/**
 * Payload para solicitar pagamento via banco (POST request-payment).
 */
export interface VehicleIpvaLicensingRequestPaymentPayload {
  vehicleId: number;
  paymentType: 'IPVA' | 'Licenciamento';
  referenceYear: number;
  amount: number;
  documentNumber?: string;
  notes?: string;
}

/**
 * Resposta da solicitação de pagamento via banco.
 */
export interface VehicleIpvaLicensingRequestPaymentResponse {
  success: boolean;
  message: string;
  history?: VehicleIpvaLicensingPaymentHistory;
  boletoUrl?: string;
}

/**
 * Payload para registrar pagamento manual (POST record-manual).
 */
export interface VehicleIpvaLicensingRecordManualPayload {
  vehicleId: number;
  paymentType: 'IPVA' | 'Licenciamento';
  referenceYear: number;
  amount: number;
  paymentDate: string;
  documentNumber?: string;
  notes?: string;
}

/**
 * Resposta do refresh de status (POST refresh-status).
 */
export interface VehicleIpvaLicensingRefreshStatusResponse {
  updated: boolean;
  message: string | null;
}
